var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkdin1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.1875 0.333252H2.8125C1.25859 0.333252 0 1.59185 0 3.14575V33.5208C0 35.0747 1.25859 36.3333 2.8125 36.3333H33.1875C34.7414 36.3333 36 35.0747 36 33.5208V3.14575C36 1.59185 34.7414 0.333252 33.1875 0.333252ZM33.8906 33.5208C33.8906 33.9075 33.5742 34.2239 33.1875 34.2239H2.8125C2.42578 34.2239 2.10938 33.9075 2.10938 33.5208V3.14575C2.10938 2.75903 2.42578 2.44263 2.8125 2.44263H33.1875C33.5742 2.44263 33.8906 2.75903 33.8906 3.14575V33.5208Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9656 14.6348H9.45703V25.8637H12.9656V14.6348Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5492 14.5293C20.5383 14.5293 19.2797 15.6262 19.0477 16.3996V14.6348H15.1031C15.1523 15.5699 15.1031 25.8637 15.1031 25.8637H19.0477V19.7957C19.0477 19.4512 19.0336 19.1137 19.132 18.8746C19.3992 18.1996 19.9828 17.4965 21.0305 17.4965C22.4016 17.4965 23.0203 18.5371 23.0203 20.0559V25.8637H27V19.6199C27 16.1465 25.0453 14.5293 22.5492 14.5293Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1375 9.33325C9.84375 9.33325 8.99297 10.17 8.99297 11.2809C8.99297 12.3708 9.81562 13.2286 11.0883 13.2286H11.1164C12.4383 13.2286 13.2609 12.3637 13.2539 11.2809C13.2258 10.17 12.4312 9.33325 11.1375 9.33325Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkdin1);
export default __webpack_public_path__ + "static/media/linkdin1.1ce0e0d1055b6f74a46c1023caa02438.svg";
export { ForwardRef as ReactComponent };